import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=028cb0ab&scoped=true"
import script from "./help-center.vue?vue&type=script&lang=js"
export * from "./help-center.vue?vue&type=script&lang=js"
import style0 from "./help-center.vue?vue&type=style&index=0&id=028cb0ab&prod&lang=less&scoped=true"
import style1 from "./help-center.vue?vue&type=style&index=1&id=028cb0ab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028cb0ab",
  null
  
)

export default component.exports